<ng-template #modalTemplate>
  <aran-modal
    [templateRef]="modalfields"
    [modalTitle]="'Confirmation'"
    [disableCloseOnOutsideClick]="true"
    [modalAction]="{
      showActions: false,
      
    }"
  ></aran-modal>

  <ng-template #modalfields>
    <form [formGroup]="form" (ngSubmit)="loginConfirm()">
      <div
        fxLayout="row wrap"
        class="form-fields"
        fxLayoutAlign="space-between center"
      >
        <aran-input
          class="w-full"
          type="text"
          label="Enter Code"
          formControlName="code"
          [errorMessages]="{
          required: errorMessages.required('Code'),
        }"
        ></aran-input>

        <div class="confirmation-form">
          <aran-button
            [type]="'submit'"
            [name]="'Confirm'"
            [disabled]="!form.get('code')?.value"
            [className]="!form.get('code')?.value ? 'btn_disabled' : ''"
          ></aran-button>
        </div>
      </div>
    </form>
  </ng-template>
</ng-template>

<div class="login-container">
  <h1 class="login-container__title">{{ appInfo.appName }}</h1>
  <p class="login-container__desc">Sign In to your account</p>
  <form
    [formGroup]="form"
    (ngSubmit)="login()"
    fxLayout="column"
    fxLayoutAlign="center"
  >
    <aran-input
      type="text"
      placeholder="Enter your email"
      label="Email"
      formControlName="email"
      (enterPressed)="onEnterPressed()"
      [errorMessages]="{
        required: errorMessages.required('Email'),
        email: errorMessages.email
      }"
    ></aran-input>

    <aran-input
      type="password"
      placeholder="Enter your password"
      label="Password"
      formControlName="password"
      [obscure]="true"
      (enterPressed)="onEnterPressed()"
      [errorMessages]="{
        required: errorMessages.required('Password'),
      }"
    ></aran-input>

    <div fxFlex="row" fxLayoutAlign="space-between start">
      <mat-checkbox class="login-container__rememberme" color="primary"
        ><span class="login-container__rememberme--text"
          >Remember me</span
        ></mat-checkbox
      >
      <a
        [routerLink]="[routeMetaData.forgetPsw.link]"
        class="login-container__forgotpsw"
        >Forgot Password?</a
      >
    </div>

    <div class="mt-2">
      <aran-button
        class="w-full"
        [type]="'submit'"
        [name]="'Login'"
        [disabled]="!form.valid"
      ></aran-button>
    </div>

    <div class="login-container__redirect-register mt-5">
      <span class="login-container__redirect-register--question"
        >Don't have an account?</span
      >
      <a
        [routerLink]="[routeMetaData.applicationForm.link]"
        class="login-container__redirect-register--link"
        >Sign Up</a
      >
    </div>
  </form>
</div>
